import React, { useState } from "react";
import { FaSearchLocation } from "react-icons/fa";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from "react-simple-maps";

const WORLD_TOPOJSON =
  "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";
const ZAMBIA_NUMERIC_ISO = "894"; // Zambia (ISO 3166-1 numeric)

export default function ZambiaLabsMap({
  filteredLabs,
  STATUS_COLORS,
  activeLab,
  setActiveLab,
}) {
  return (
    <div style={{ width: "100%", maxWidth: 900, margin: "0 auto" }}>
      <h2 className="mb-0">
        <FaSearchLocation className="me-2" />
        Zambia Laboratory Distribution
      </h2>
      <p>Interactive map showing laboratories with real-time status</p>

      <style>
        {`
          @keyframes pulse {
            0% { r: 4; opacity: 0.9; }
            50% { r: 14; opacity: 0.3; }
            100% { r: 4; opacity: 0; }
          }
          .pulse-circle {
            animation: pulse 1.2s infinite;
          }
        `}
      </style>

      <div style={{ padding: 8 }}>
        <ComposableMap
          projectionConfig={{ scale: 1500 }}
          style={{ width: "100%", height: "480px" }}
        >
          <ZoomableGroup
            center={[27.8, -13.0]}
            zoom={2.0}
            minZoom={2.0}
            maxZoom={2.0}
            disableZooming={true}
            disablePanning={true}
          >
            <Geographies geography={WORLD_TOPOJSON}>
              {({ geographies }) =>
                geographies
                  .filter((geo) => geo.id?.toString() === ZAMBIA_NUMERIC_ISO)
                  .map((geo) => (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      style={{
                        default: {
                          fill: "none",
                          outline: "none",
                          stroke: "#065f46",
                          strokeWidth: 0.8,
                        },
                        hover: {
                          fill: "none",
                          outline: "none",
                          stroke: "#065f46",
                        },
                        pressed: {
                          fill: "none",
                          outline: "none",
                          stroke: "#065f46",
                        },
                      }}
                    />
                  ))
              }
            </Geographies>

            {filteredLabs.map((lab, idx) => (
              <Marker
                key={`${lab.labName}-${idx}`}
                coordinates={lab.coordinates}
                onClick={() => setActiveLab(lab)}
                style={{ cursor: "pointer" }}
              >
                {/* Pulse Circle */}
                {activeLab === lab && (
                  <circle
                    className="pulse-circle"
                    r={4}
                    fill={STATUS_COLORS[lab.status] || "#111827"}
                    stroke="white"
                    strokeWidth={1.2}
                  />
                )}

                {/* Main Dot */}
                <circle
                  r={4}
                  fill={STATUS_COLORS[lab.status] || "#111827"}
                  stroke="#ffffff"
                  strokeWidth={1.2}
                  style={{
                    transition: "r 0.25s ease-in-out",
                  }}
                  onMouseEnter={(e) => e.target.setAttribute("r", 8)}
                  onMouseLeave={(e) => e.target.setAttribute("r", 4)}
                />
              </Marker>
            ))}
          </ZoomableGroup>
        </ComposableMap>
      </div>
    </div>
  );
}
